declare namespace $ {

	type $mol_string_button__value_shm_hitalama_entity_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_page['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_button_minor__title_shm_hitalama_entity_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_page['cut_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_entity_page_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_page['cut'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_entity_page extends $mol_page {
		title( next?: string ): string
		Title( ): $mol_string_button
		cut_title( ): string
		cut( next?: any ): any
		Cut( ): $mol_button_minor
		entity( ): $giper_baza_entity
		head( ): readonly(any)[]
		tools( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map